import centerCheck from "@/public/hero/centerCheck.png"
import USDCIcon from "@/public/hero/usdc.png"
import BTCIcon from "@/public/hero/btc.png"
import USDTIcon from "@/public/hero/usdt.png"
import NGNIcon from "@/public/hero/ngn.png"
import GHANAIcon from "@/public/hero/ghana.png"
import KenyaIcon from "@/public/hero/kenya.png"

export { centerCheck, USDCIcon, BTCIcon, USDTIcon, NGNIcon, GHANAIcon, KenyaIcon }